import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 羽毛球：【汤尤杯|苏迪曼杯】
import badmintonRouter from '@router/badminton/commonRouter'
// 【汤尤杯】
import badmintonRouter_thomasAndUberRouter from '@router/badminton/cup_thomasAndUber'
// 【苏迪曼杯】
import badmintonRouter_sudirmanRouter from '@router/badminton/cup_sudirman'

const {
  BadmintonScheduleIndex,
  BadmintonScheduleDetail,
  BadmintonScheduleDetailStartList,
  BadmintonScheduleDetailLocalData,
  BadmintonScheduleDetailDataAnalysis,
  BadmintonLeagueTableIndex,
  BadmintonKnockoutRoundsIndex,
  BadmintonEventsThemeListIndex,
  //   BadmintonDelegationIndex,
  //   BadmintonDelegationDetailIndex,
  //   BadmintonDelegationDetailSchedule,
  //   BadmintonDelegationDetailPlayer,
  //   BadmintonDelegationDetailMedalList,
  //   BadmintonPlayerIndex,
  //   BadmintonPlayerDetailIndex,
  //   BadmintonRecordIndex,
  //   BadmintonVenueIndex,
  BadmintonBroadcastListIndex,
  BadmintonDataPackagListIndex,
  BadmintonProgramListIndex,
} = badmintonRouter

const { PlatfromBadmintonCupFullThomasAndUber } =
  badmintonRouter_thomasAndUberRouter

const { PlatfromBadmintonCupFullSudirman } = badmintonRouter_sudirmanRouter

const pathModuleBase = 'PlatfromBadmintonCupFull'
const diffCompetitionTypeArr = [
  {
    name: 'BDMTAU',
    pathModule: 'thomasAndUber',
    component: PlatfromBadmintonCupFullThomasAndUber,
  }, // 汤尤杯
  {
    name: 'BDMSC',
    pathModule: 'sudirman',
    component: PlatfromBadmintonCupFullSudirman,
  }, // 苏迪曼杯
]

const baseChildren = [
  {
    path: 'schedule', //赛程
    name: 'badmintonScheduleIndex', // badmintonScheduleIndex_BDMTAU
    component: BadmintonScheduleIndex,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'schedule'],
      requireLogin: false,
      title: '赛程',
    },
  },
  {
    path: 'scheduleDetail', //赛程详情
    redirect: { name: 'badmintonScheduleDetailStartList' },
    name: 'badmintonScheduleDetail',
    component: BadmintonScheduleDetail,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'schedule'],
      requireLogin: false,
    },
    children: [
      {
        path: 'startList', //出场名单
        name: 'badmintonScheduleDetailStartList',
        component: BadmintonScheduleDetailStartList,
        meta: {
          pathModule: ['badminton', 'thomasAndUber', 'schedule'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'localData', //本次数据
        name: 'badmintonScheduleDetailLocalData',
        component: BadmintonScheduleDetailLocalData,
        meta: {
          pathModule: ['badminton', 'thomasAndUber', 'schedule'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'dataAnalysis', //数据分析
        name: 'badmintonScheduleDetailDataAnalysis',
        component: BadmintonScheduleDetailDataAnalysis,
        meta: {
          pathModule: ['badminton', 'thomasAndUber', 'schedule'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
    ],
  },
  {
    path: 'leagueTable', //积分榜
    name: 'badmintonLeagueTableIndex',
    component: BadmintonLeagueTableIndex,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'leagueTable'],
      requireLogin: false,
      title: '积分榜',
    },
  },
  {
    path: 'knockoutRounds', //淘汰赛
    name: 'badmintonKnockoutRoundsIndex',
    component: BadmintonKnockoutRoundsIndex,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'knockoutRounds'],
      requireLogin: false,
      title: '淘汰赛',
    },
  },
  {
    path: 'eventsThemeList', //晋级之路
    name: 'badmintonEventsThemeListIndex',
    component: BadmintonEventsThemeListIndex,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'eventsThemeList'],
      requireLogin: false,
      title: '晋级之路',
    },
  },

  // {
  //   path: 'delegation', //代表团
  //   name: 'badmintonDelegationIndex',
  //   component: BadmintonDelegationIndex,
  //   meta: {
  //     pathModule: ['badminton', 'thomasAndUber', 'delegation'],
  //     requireLogin: false,
  //     title: '代表团',
  //   },
  // },
  // {
  //   path: 'delegationDetail', //代表团详情
  //   redirect: { name: 'badmintonDelegationDetailSchedule' },
  //   name: 'badmintonDelegationDetailIndex',
  //   component: BadmintonDelegationDetailIndex,
  //   meta: {
  //     pathModule: ['badminton', 'thomasAndUber', 'delegation'],
  //     requireLogin: false,
  //   },
  //   children: [
  //     {
  //       path: 'schedule', //代表团详情-赛程
  //       name: 'badmintonDelegationDetailSchedule',
  //       component: BadmintonDelegationDetailSchedule,
  //       meta: {
  //         pathModule: ['badminton', 'thomasAndUber', 'delegation'],
  //         requireLogin: false,
  //         title: '代表团详情',
  //       },
  //     },
  //     {
  //       path: 'player', //代表团详情-参赛选手
  //       name: 'badmintonDelegationDetailPlayer',
  //       component: BadmintonDelegationDetailPlayer,
  //       meta: {
  //         pathModule: ['badminton', 'thomasAndUber', 'delegation'],
  //         requireLogin: false,
  //         title: '代表团详情',
  //       },
  //     },
  //     {
  //       path: 'medalList', //代表团详情-获奖明细
  //       name: 'badmintonDelegationDetailMedalList',
  //       component: BadmintonDelegationDetailMedalList,
  //       meta: {
  //         pathModule: ['badminton', 'thomasAndUber', 'delegation'],
  //         requireLogin: false,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: 'player', //运动员
  //   name: 'badmintonPlayerIndex',
  //   component: BadmintonPlayerIndex,
  //   meta: {
  //     pathModule: ['badminton', 'thomasAndUber', 'player'],
  //     requireLogin: false,
  //     title: '运动员',
  //   },
  // },
  // {
  //   path: 'playerDetail', //运动员详情
  //   name: 'badmintonPlayerDetailIndex',
  //   component: BadmintonPlayerDetailIndex,
  //   meta: {
  //     pathModule: ['badminton', 'thomasAndUber', 'player'],
  //     requireLogin: false,
  //     title: '运动员详情',
  //   },
  // },
  // {
  //   path: 'record', //纪录
  //   name: 'badmintonRecordIndex',
  //   component: BadmintonRecordIndex,
  //   meta: {
  //     pathModule: ['badminton', 'thomasAndUber', 'record'],
  //     requireLogin: false,
  //     title: '纪录',
  //   },
  // },
  // {
  //   path: 'venue', //场馆
  //   name: 'badmintonVenueIndex',
  //   component: BadmintonVenueIndex,
  //   meta: {
  //     pathModule: ['badminton', 'thomasAndUber', 'venue'],
  //     requireLogin: false,
  //     title: '场馆',
  //   },
  // },
  {
    path: 'broadcastList', //播出单
    name: 'badmintonBroadcastListIndex',
    component: BadmintonBroadcastListIndex,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //数据包装
    name: 'badmintonDataPackagListIndex',
    component: BadmintonDataPackagListIndex,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //节目单
    name: 'badmintonProgramListIndex',
    component: BadmintonProgramListIndex,
    meta: {
      pathModule: ['badminton', 'thomasAndUber', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)

const routerModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /thomasAndUber
  name: `${pathModuleBase}_${routerItem.name}`, // PlatfromBadmintonCupFull_thomasAndUber
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))

export default {
  badminton_thomasAndUber_RouterMode: routerModeArr[0],
  badminton_sudirman_RouterMode: routerModeArr[1],
}
